import { css } from '@linaria/core'

export const elIntentPrimary = css``

export const elIntentNeutral = css``

export const elIntentSuccess = css``

export const elIntentPending = css``

export const elIntentWarning = css``

export const elIntentDanger = css``

export const elIntentDefault = css``

/** @deprecated - will be removed in v5 */
export const elIntentLow = css``
/** @deprecated - will be removed in v5 */
export const elIntentSecondary = css``
/** @deprecated - will be removed in v5 */
export const elIntentCritical = css``
